import React, { useEffect, useRef, useState } from "react";
import {
  Alert,
  Box,
  Card,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  Typography,
} from "@mui/material";

import PaymentCards from "./PaymentCards";
import { Button } from "reactstrap";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import CustomButton from "../../../reusableComponents/CustomButton";
import PaymentOpions from "./PaymentOpions";
import paymentCategoryLogoDictionary from "../../paymentCategoryLogoDictionary";

function SelectedPsps(props) {
  const isFirstRender = useRef(true);

  const pspCode = props.obj.value;
  const cardOptions = props.getMethodsForPspAndType(pspCode, "Card");
  const walletOptions = props.getMethodsForPspAndType(pspCode, "Wallet");
  const bnplOptions = props.getMethodsForPspAndType(pspCode, "BuyNowPayLater");
  const netbankingOptions = props.getMethodsForPspAndType(
    pspCode,
    "NetBanking"
  );
  const upiOptions = props.getMethodsForPspAndType(pspCode, "Upi");
  const cryptoOptions = props.getMethodsForPspAndType(pspCode, "Crypto");
  const PaynowOptions = props.getMethodsForPspAndType(pspCode, "Paynow");

  const [cardSelects, setCardSelects] = useState([]);
  const [walletSelects, setWalletSelects] = useState([]);
  const [bnplSelects, setBnplSelects] = useState([]);
  const [NetBankingSelects, setNetBankingSelects] = useState([]);
  const [upiSelects, setUpiSelects] = useState([]);
  const [cryptoSelects, setCryptoSelects] = useState([]);
  const [PaynowSelects, setPaynowSelects] = useState([]);

  const [show, setShow] = useState(false);
  const [change, setChange] = useState(false);
  const [on, setOn] = useState(false);

  const handleShow = () => {
    if (!show) {
      if (props.shown) {
        props.setOff(!props.off);
        props.setShown(false);
        setChange(true);
        setOn(!on);
        setToggleCard(false);
        setToggleWallet(false);
        setToggleNetBanking(false);
        setToggleBNPL(false);
        setToggleUpi(false);
        setToggleCrypto(false);
        setTogglePaynow(false);
        props.setToggled(false);
      } else {
        props.setShown(!props.shown);
        setShow(!show);
        if (
          toggleCard ||
          toggleWallet ||
          toggleNetBanking ||
          toggleBNPL ||
          toggleUpi ||
          toggleCrypto ||
          togglePaynow
        )
          props.setToggled(true);
        else props.setToggled(false);
      }
    } else {
      props.setShown(!props.shown);
      setShow(!show);
      props.setToggled(false);
    }
  };

  useEffect(() => {
    setShow(false);
  }, [props.off]);

  useEffect(() => {
    if (change === true) {
      setShow(true);
      props.setShown(true);
    }
  }, [on]);

  useEffect(() => {
    if (props.index === 0) handleShow();
  }, []);
  const [toggleCard, setToggleCard] = useState(false);
  const [toggleWallet, setToggleWallet] = useState(false);
  const [toggleBNPL, setToggleBNPL] = useState(false);
  const [toggleNetBanking, setToggleNetBanking] = useState(false);
  const [toggleUpi, setToggleUpi] = useState(false);
  const [toggleCrypto, setToggleCrypto] = useState(false);
  const [togglePaynow, setTogglePaynow] = useState(false);

  const [allCheckedCards, setAllCheckedCards] = useState(false);
  const [clickedAllCards, setClickedAllCards] = useState(false);
  const [allCheckedWallet, setAllCheckedWallet] = useState(false);
  const [clickedAllWallet, setClickedAllWallet] = useState(false);
  const [allCheckedNetBanking, setAllCheckedNetBanking] = useState(false);
  const [clickedAllNetBanking, setClickedAllNetBanking] = useState(false);
  const [allCheckedBNPL, setAllCheckedBNPL] = useState(false);
  const [clickedAllBNPL, setClickedAllBNPL] = useState(false);
  const [allCheckedUPI, setAllCheckedUPI] = useState(false);
  const [clickedAllUPI, setClickedAllUPI] = useState(false);
  const [allCheckedCrypto, setAllCheckedCrypto] = useState(false);
  const [clickedAllCrypto, setClickedAllCrypto] = useState(false);
  const [allCheckedPaynow, setAllCheckedPaynow] = useState(false);
  const [clickedAllPaynow, setClickedAllPaynow] = useState(false);

  useEffect(() => {
    if (clickedAllCards === true) setCountCards(cardOptions.length);
    else setCountCards(0);

    if (clickedAllWallet === true) setCountWallet(walletOptions.length);
    else setCountWallet(0);

    if (clickedAllNetBanking === true)
      setCountNetBanking(netbankingOptions.length);
    else setCountNetBanking(0);

    if (clickedAllBNPL === true) setCountBNPL(bnplOptions.length);
    else setCountBNPL(0);

    if (clickedAllUPI === true) setCountUPI(upiOptions.length);
    else setCountUPI(0);

    if (clickedAllCrypto === true) setCountCrypto(cryptoOptions.length);
    else setCountCrypto(0);

    if (clickedAllPaynow === true) setCountPaynow(PaynowOptions.length);
    else setCountPaynow(0);
  }, [
    clickedAllCards,
    clickedAllWallet,
    clickedAllNetBanking,
    clickedAllBNPL,
    clickedAllUPI,
    clickedAllCrypto,
    clickedAllPaynow,
  ]);

  const handleAllCheckCards = (event) => {
    setClickedAllCards(!clickedAllCards);
    if (!clickedAllCards) {
      setCardSelects(
        cardOptions.map((obj) => ({
          title: obj.title,
          id: obj.id,
          type: obj.type,
          typeTitle: obj.typeTitle,
          logoUrl: obj.logoUrl,
        }))
      );
    } else setCardSelects([]);
  };

  const handleAllCheckWallet = (event) => {
    setClickedAllWallet(!clickedAllWallet);
    if (!clickedAllWallet) {
      setWalletSelects(
        walletOptions.map((obj) => ({
          title: obj.title,
          id: obj.id,
          type: obj.type,
          typeTitle: obj.typeTitle,
          logoUrl: obj.logoUrl,
        }))
      );
    } else setWalletSelects([]);
  };

  const handleAllCheckNetBanking = (event) => {
    setClickedAllNetBanking(!clickedAllNetBanking);
    if (!clickedAllNetBanking) {
      setNetBankingSelects(
        netbankingOptions.map((obj) => ({
          title: obj.title,
          id: obj.id,
          type: obj.type,
          typeTitle: obj.typeTitle,
          logoUrl: obj.logoUrl,
        }))
      );
    } else setNetBankingSelects([]);
  };

  const handleAllCheckBNPL = (event) => {
    setClickedAllBNPL(!clickedAllBNPL);
    if (!clickedAllBNPL) {
      setBnplSelects(
        bnplOptions.map((obj) => ({
          title: obj.title,
          id: obj.id,
          type: obj.type,
          typeTitle: obj.typeTitle,
          logoUrl: obj.logoUrl,
        }))
      );
    } else setBnplSelects([]);
  };

  const handleAllCheckUpi = (event) => {
    setClickedAllUPI(!clickedAllUPI);
    if (!clickedAllUPI) {
      setUpiSelects(
        upiOptions.map((obj) => ({
          title: obj.title,
          id: obj.id,
          type: obj.type,
          typeTitle: obj.typeTitle,
          logoUrl: obj.logoUrl,
        }))
      );
    } else setUpiSelects([]);
  };

  const handleAllCheckCrypto = (event) => {
    setClickedAllCrypto(!clickedAllCrypto);
    if (!clickedAllCrypto) {
      setCryptoSelects(
        cryptoOptions.map((obj) => ({
          title: obj.title,
          id: obj.id,
          type: obj.type,
          typeTitle: obj.typeTitle,
          logoUrl: obj.logoUrl,
        }))
      );
    } else setCryptoSelects([]);
  };

  const handleAllCheckPaynow = (event) => {
    setClickedAllPaynow(!clickedAllPaynow);
    if (!clickedAllPaynow) {
      setPaynowSelects(
        PaynowOptions.map((obj) => ({
          title: obj.title,
          id: obj.id,
          type: obj.type,
          typeTitle: obj.typeTitle,
          logoUrl: obj.logoUrl,
        }))
      );
    } else setPaynowSelects([]);
  };

  const handelClickCard = () => {
    setToggleWallet(false);
    setToggleNetBanking(false);
    setToggleBNPL(false);
    setToggleUpi(false);
    setToggleCrypto(false);
    setTogglePaynow(false);
    setToggleCard(!toggleCard);
    props.setToggled(!toggleCard);
  };

  const handelClickWallet = () => {
    setToggleNetBanking(false);
    setToggleBNPL(false);
    setToggleUpi(false);
    setToggleCard(false);
    setToggleCrypto(false);
    setTogglePaynow(false);
    setToggleWallet(!toggleWallet);
    props.setToggled(!toggleWallet);
  };

  const handelClickBNPL = () => {
    setToggleNetBanking(false);
    setToggleUpi(false);
    setToggleCard(false);
    setToggleWallet(false);
    setToggleCrypto(false);
    setTogglePaynow(false);
    setToggleBNPL(!toggleBNPL);
    props.setToggled(!toggleBNPL);
  };

  const handelClickNetBanking = () => {
    setToggleBNPL(false);
    setToggleUpi(false);
    setToggleCard(false);
    setToggleWallet(false);
    setToggleCrypto(false);
    setTogglePaynow(false);
    setToggleNetBanking(!toggleNetBanking);
    props.setToggled(!toggleNetBanking);
  };

  const handelClickUpi = () => {
    setToggleNetBanking(false);
    setToggleBNPL(false);
    setToggleCard(false);
    setToggleWallet(false);
    setToggleCrypto(false);
    setTogglePaynow(false);
    setToggleUpi(!toggleUpi);
    props.setToggled(!toggleUpi);
  };

  const handelClickCrypto = () => {
    setToggleCard(false);
    setToggleWallet(false);
    setToggleNetBanking(false);
    setToggleBNPL(false);
    setToggleUpi(false);
    setTogglePaynow(false);
    setToggleCrypto(!toggleCrypto);
    props.setToggled(!toggleCrypto);
  };

  const handelClickPaynow = () => {
    setToggleCard(false);
    setToggleWallet(false);
    setToggleNetBanking(false);
    setToggleBNPL(false);
    setToggleUpi(false);
    setToggleCrypto(false);
    setTogglePaynow(!togglePaynow);
    props.setToggled(!togglePaynow);
  };
  const [countCards, setCountCards] = useState(0);
  const [countWallet, setCountWallet] = useState(0);
  const [countNetBanking, setCountNetBanking] = useState(0);
  const [countBNPL, setCountBNPL] = useState(0);
  const [countUPI, setCountUPI] = useState(0);
  const [countCrypto, setCountCrypto] = useState(0);
  const [countPaynow, setCountPaynow] = useState(0);

  useEffect(() => {
    if (countCards < cardOptions.length || cardOptions.length == 0)
      setAllCheckedCards(false);
    else setAllCheckedCards(true);

    if (countWallet < walletOptions.length || walletOptions.length == 0)
      setAllCheckedWallet(false);
    else setAllCheckedWallet(true);

    if (
      countNetBanking < netbankingOptions.length ||
      netbankingOptions.length == 0
    )
      setAllCheckedNetBanking(false);
    else setAllCheckedNetBanking(true);

    if (countBNPL < bnplOptions.length || bnplOptions.length == 0)
      setAllCheckedBNPL(false);
    else setAllCheckedBNPL(true);

    if (countUPI < upiOptions.length || upiOptions.length == 0)
      setAllCheckedUPI(false);
    else setAllCheckedUPI(true);

    if (countCrypto < cryptoOptions.length || cryptoOptions.length == 0)
      setAllCheckedCrypto(false);
    else setAllCheckedCrypto(true);

    if (countPaynow < PaynowOptions.length || PaynowOptions.length == 0)
      setAllCheckedPaynow(false);
    else setAllCheckedPaynow(true);
  }, [
    countCards,
    countWallet,
    countNetBanking,
    countBNPL,
    countUPI,
    countCrypto,
    countPaynow,
  ]);

  useEffect(() => {
    const options = sessionStorage.getItem("storeOptions");
    const getOptions = JSON.parse(options);
    if (sessionStorage.getItem("storeOptions")) {
      for (let i = 0; i < getOptions.length; i++) {
        if (getOptions[i].pspCode === props.obj.value) {
          setCardSelects(getOptions[i].cardSelects);
          setWalletSelects(getOptions[i].walletSelects);
          setBnplSelects(getOptions[i].bnplSelects);
          setNetBankingSelects(getOptions[i].NetBankingSelects);
          setUpiSelects(getOptions[i].upiSelects);
          setCryptoSelects(getOptions[i].cryptoSelects);
          setPaynowSelects(getOptions[i].PaynowSelects);

          setClickedAllCards(getOptions[i].clickedAllCards);
          setClickedAllWallet(getOptions[i].clickedAllWallet);
          setClickedAllBNPL(getOptions[i].clickedAllBNPL);
          setClickedAllNetBanking(getOptions[i].clickedAllNetBanking);
          setClickedAllUPI(getOptions[i].clickedAllUPI);
          setClickedAllCrypto(getOptions[i].clickedAllCrypto);
          setClickedAllPaynow(getOptions[i].clickedAllPaynow);
        }
      }
    }
  }, []);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    const data = [
      {
        pspCode: props.obj.value,
        cardSelects: cardSelects,
        walletSelects: walletSelects,
        bnplSelects: bnplSelects,
        NetBankingSelects: NetBankingSelects,
        upiSelects: upiSelects,
        cryptoSelects: cryptoSelects,
        PaynowSelects: PaynowSelects,

        clickedAllCards: clickedAllCards,
        clickedAllWallet: clickedAllWallet,
        clickedAllBNPL: clickedAllBNPL,
        clickedAllNetBanking: clickedAllNetBanking,
        clickedAllUPI: clickedAllUPI,
        clickedAllCrypto: clickedAllCrypto,
        clickedAllPaynow: clickedAllPaynow,
      },
    ];

    if (!props.storeOptions.find((ele) => ele.pspCode === data[0].pspCode)) {
      const newdata = [...props.storeOptions, ...data];
      props.setStoreOptions(newdata);
    } else {
      const arr = props.storeOptions.filter(
        (v) => v.pspCode !== data[0].pspCode
      );

      const newdata = [...arr, ...data];
      props.setStoreOptions(newdata);
    }

    setCountCards(cardSelects.length);
    setCountWallet(walletSelects.length);
    setCountBNPL(bnplSelects.length);
    setCountNetBanking(NetBankingSelects.length);
    setCountUPI(upiSelects.length);
    setCountCrypto(cryptoSelects.length);
    setCountPaynow(PaynowSelects.length);
  }, [
    cardSelects,
    walletSelects,
    bnplSelects,
    NetBankingSelects,
    upiSelects,
    cryptoSelects,
    PaynowSelects,
  ]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    sessionStorage.setItem("storeOptions", JSON.stringify(props.storeOptions));
  }, [props.storeOptions]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    let ids = [];

    cardSelects.map((obj) => ids.push(obj.id));

    walletSelects.map((obj) => ids.push(obj.id));

    bnplSelects.map((obj) => ids.push(obj.id));

    NetBankingSelects.map((obj) => ids.push(obj.id));

    upiSelects.map((obj) => ids.push(obj.id));

    cryptoSelects.map((obj) => ids.push(obj.id));

    PaynowSelects.map((obj) => ids.push(obj.id));

    const alldata = [
      {
        pspCode: props.obj.value,
        Ids: ids,
      },
    ];
    const arr = props.paymentOptionsIds.filter(
      (v) => v.pspCode !== props.obj.value
    );

    const newdata = [...arr, ...alldata];
    props.setPaymentOptionsIds(newdata);
  }, [
    cardSelects,
    walletSelects,
    bnplSelects,
    NetBankingSelects,
    upiSelects,
    cryptoSelects,
    PaynowSelects,
  ]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    const alldata = [
      {
        pspCode: props.obj.value,
        logoUrl: props.obj.logoUrl,
        title: props.obj.title,
        Cards: countCards,
        Wallet: countWallet,
        BuyNowPayLater: countBNPL,
        NetBanking: countNetBanking,
        UPI: countUPI,
        Crypto: countCrypto,
        Paynow: countPaynow,
        cardSelects: cardSelects,
        walletSelects: walletSelects,
        bnplSelects: bnplSelects,
        NetBankingSelects: NetBankingSelects,
        upiSelects: upiSelects,
        cryptoSelects: cryptoSelects,
        PaynowSelects: PaynowSelects,
      },
    ];

    if (
      !props.paymentOptions.find((ele) => ele.pspCode === alldata[0].pspCode)
    ) {
      const newdata = [...props.paymentOptions, ...alldata];
      props.setPaymentOptions(newdata);
    } else {
      const arr = props.paymentOptions.filter(
        (v) => v.pspCode !== alldata[0].pspCode
      );
      const newdata = [...arr, ...alldata];
      props.setPaymentOptions(newdata);
    }
  }, [
    countCards,
    countWallet,
    countNetBanking,
    countBNPL,
    countUPI,
    countCrypto,
    countPaynow,
    cardSelects,
    walletSelects,
    bnplSelects,
    NetBankingSelects,
    upiSelects,
    cryptoSelects,
    PaynowSelects,
  ]);

  return (
    <div
      key={pspCode + "-form-container"}
      style={{ width: "250px", height: "64vh" }}
    >
      <div
        style={{ display: "flex", justifyContent: "space-between" }}
        onClick={handleShow}
      >
        <div>
          <Typography
            className="main-page-title"
            sx={{ fontSize: 16, marginTop: 2, marginBottom: 3 }}
          >
            <img src={props.obj.logoUrl} width={24} />
            {props.obj.title}
            <Divider style={{ width: "280px", paddingTop: "12px" }}></Divider>
          </Typography>
        </div>
        <div>
          <img
            style={{
              height: "10px",
              width: "10px",
              marginLeft: "-12px",
              marginTop: "28px",
            }}
            src={show ? "/upArrow.png" : "/downArrow.png"}
          />
        </div>
      </div>

      {show && (
        <>
          {cardOptions?.length > 0 && (
            <PaymentOpions
              toggle={toggleCard}
              src={paymentCategoryLogoDictionary["Card"]?.logoColored}
              title={"Cards"}
              count={countCards}
              handleClick={handelClickCard}
              allChecked={allCheckedCards}
              handleAllCheck={handleAllCheckCards}
              options={cardOptions}
              setCount={setCountCards}
              selects={cardSelects}
              setSelects={setCardSelects}
              clickedAll={clickedAllCards}
              paymentOptionsIds={props.paymentOptionsIds}
              pspCode={pspCode}
            />
          )}

          {walletOptions?.length > 0 && (
            <>
              <div style={{ height: "10px" }}></div>
              <PaymentOpions
                toggle={toggleWallet}
                src={paymentCategoryLogoDictionary["Wallet"]?.logoColored}
                title={"Wallet"}
                count={countWallet}
                handleClick={handelClickWallet}
                allChecked={allCheckedWallet}
                handleAllCheck={handleAllCheckWallet}
                options={walletOptions}
                setCount={setCountWallet}
                selects={walletSelects}
                setSelects={setWalletSelects}
                clickedAll={clickedAllWallet}
                paymentOptionsIds={props.paymentOptionsIds}
                pspCode={pspCode}
              />
            </>
          )}
          {bnplOptions?.length > 0 && (
            <>
              <div style={{ height: "10px" }}></div>
              <PaymentOpions
                toggle={toggleBNPL}
                src={
                  paymentCategoryLogoDictionary["BuyNowPayLater"]?.logoColored
                }
                title={"BuyNowPayLater"}
                count={countBNPL}
                handleClick={handelClickBNPL}
                allChecked={allCheckedBNPL}
                handleAllCheck={handleAllCheckBNPL}
                options={bnplOptions}
                setCount={setCountBNPL}
                selects={bnplSelects}
                setSelects={setBnplSelects}
                clickedAll={clickedAllBNPL}
                paymentOptionsIds={props.paymentOptionsIds}
                pspCode={pspCode}
              />
            </>
          )}

          {netbankingOptions?.length > 0 && (
            <>
              <div style={{ height: "10px" }}></div>
              <PaymentOpions
                toggle={toggleNetBanking}
                src={paymentCategoryLogoDictionary["NetBanking"]?.logoColored}
                title={"NetBanking"}
                count={countNetBanking}
                handleClick={handelClickNetBanking}
                allChecked={allCheckedNetBanking}
                handleAllCheck={handleAllCheckNetBanking}
                options={netbankingOptions}
                setCount={setCountNetBanking}
                selects={NetBankingSelects}
                setSelects={setNetBankingSelects}
                clickedAll={clickedAllNetBanking}
                paymentOptionsIds={props.paymentOptionsIds}
                pspCode={pspCode}
              />
            </>
          )}

          {upiOptions?.length > 0 && (
            <>
              <div style={{ height: "10px" }}></div>
              <PaymentOpions
                toggle={toggleUpi}
                src={paymentCategoryLogoDictionary["Upi"]?.logoColored}
                title={"UPI"}
                count={countUPI}
                handleClick={handelClickUpi}
                allChecked={allCheckedUPI}
                handleAllCheck={handleAllCheckUpi}
                options={upiOptions}
                setCount={setCountUPI}
                selects={upiSelects}
                setSelects={setUpiSelects}
                clickedAll={clickedAllUPI}
                paymentOptionsIds={props.paymentOptionsIds}
                pspCode={pspCode}
              />
            </>
          )}

          {cryptoOptions?.length > 0 && (
            <>
              <div style={{ height: "10px" }}></div>
              <PaymentOpions
                toggle={toggleCrypto}
                src={paymentCategoryLogoDictionary["Crypto"]?.logoColored}
                title={"Crypto"}
                count={countCrypto}
                handleClick={handelClickCrypto}
                allChecked={allCheckedCrypto}
                handleAllCheck={handleAllCheckCrypto}
                options={cryptoOptions}
                setCount={setCountCrypto}
                selects={cryptoSelects}
                setSelects={setCryptoSelects}
                clickedAll={clickedAllCrypto}
                paymentOptionsIds={props.paymentOptionsIds}
                pspCode={pspCode}
              />
            </>
          )}

          {PaynowOptions?.length > 0 && (
            <>
              <div style={{ height: "10px" }}></div>
              <PaymentOpions
                toggle={togglePaynow}
                src={paymentCategoryLogoDictionary["Paynow"]?.logoColored}
                title={"Paynow"}
                count={countPaynow}
                handleClick={handelClickPaynow}
                allChecked={allCheckedPaynow}
                handleAllCheck={handleAllCheckPaynow}
                options={PaynowOptions}
                setCount={setCountPaynow}
                selects={PaynowSelects}
                setSelects={setPaynowSelects}
                clickedAll={clickedAllPaynow}
                paymentOptionsIds={props.paymentOptionsIds}
                pspCode={pspCode}
              />
            </>
          )}
        </>
      )}
    </div>
  );
}

export default SelectedPsps;
